/**
 * 需要想定 draft 保存 mutation hook。
 *
 * SaveDemandForecastDraft RPC を呼んで小売 1 件の 48コマを保存する。
 * レスポンスの updated_at を caller 側で draftUpdatedAt に反映させること。
 * 保存の成功時に、 進行中の page 取得を保存の後の取得として出し直す (#9296)。
 */
import type { MessageInitShape, MessageShape } from '@bufbuild/protobuf'
import type { ConnectError } from '@connectrpc/connect'
import { useMutation } from '@connectrpc/connect-query'
import { saveDemandForecastDraft } from '@ebalance/proto/bffuser/v1/demand_forecast_service-DemandForecastService_connectquery'
import {
  SaveDemandForecastDraftRequestSchema,
  SaveDemandForecastDraftResponseSchema,
} from '@ebalance/proto/bffuser/v1/demand_forecast_service_pb'
import type { UseMutationResult } from '@tanstack/react-query'

import { useRestartInFlightDemandForecastDailyFetches } from './useGetDemandForecastDaily'

/**
 * 小売 1 件の draft を保存する mutation hook。
 * request は caller が `create(SaveDemandForecastDraftRequestSchema, {...})` で組み立てて渡す。
 */
export function useSaveDemandForecastDraft(): UseMutationResult<
  MessageShape<typeof SaveDemandForecastDraftResponseSchema>,
  ConnectError,
  MessageInitShape<typeof SaveDemandForecastDraftRequestSchema>
> {
  const restartInFlightPageFetches =
    useRestartInFlightDemandForecastDailyFetches()
  return useMutation(saveDemandForecastDraft, {
    onSuccess: restartInFlightPageFetches,
  })
}
